import React from 'react';
import {Layout} from "antd";
import QwHeader from "./header";
import QwSider from "./sider";
import {Redirect, Route, Switch} from "react-router-dom";
import Contact from "./contact";
import Customer from "../customer";
import Fission from "../fission";
import Drainage from "../drainage";
import Market from "../market";
import ConfigManage from "../config/configManage";
import AssetsRouter from '../assets/assets_router'
import CorpApi from "../public/corp_api";
import StepByStep from "../config/corp/stepByStep";
import QwStep from "../config/scanstep/qw_step";
import CloudApi from "../cloud/cloud_api";
import Store from "../store";
import PubSub from "pubsub-js";
import {connect} from "react-redux";


const {Content} = Layout;

class Index extends React.Component {

    constructor(props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
        this.state = {
            isComplete: 1,
            customerServiceFlag: 1,
            accountMessage:{}
        }
    }

    componentDidMount() {
        // this.handleResize();
        // window.addEventListener('resize', this.handleResize);
    }

    componentWillMount() {
        CorpApi.getUserOpenId((data) => {
            this.setState({
                accountMessage: data
            })
            Store.setUserInfo(data);
        })
        CorpApi.getEnterpriseWechatAuthoriztionStuatus((data) => {
            let isComplete = data.isComplete;
            this.setState({
                isComplete: isComplete
            })
        })

        CloudApi.getUserAddCustStatus(data => {
            //0未添加，1已添加
            this.setState({
                customerServiceFlag: data.customerserviceflag
            })
        })
    }

    handleResize() {
        let width = window.innerWidth;
        if (width > 1300) {
            this.toggleSiderCollapsed(false);
        } else {
            this.toggleSiderCollapsed(true);
        }
    }

    toggleSiderCollapsed = (val) => {
        if (this.qySiderRef) {
            this.qySiderRef.collapseChange(val);
        }
    };

    render() {
        const {customerServiceFlag, isComplete,accountMessage} = this.state
        return (
            <Layout className='qy-layout'>
                <QwHeader key='qyHeader' toggleSiderCollapsed={this.toggleSiderCollapsed} history={this.props.history} type='2'/>
                <Layout>
                    <QwSider key='qySider' ref={r => this.qySiderRef = r} history={this.props.history} accountMessage={accountMessage}/>
                    <Content className='qy-content-wraper'>
                        <div className='qy-content'
                             style={{background: customerServiceFlag == 1 ? '#FFFFFF' : '#F3F5F7'}}>
                            <Contact/>
                            <Switch>
                                <Route path={this.props.match.url + "/market"}
                                       component={customerServiceFlag == 0 ? QwStep : Market}/>
                                <Route path={this.props.match.url + "/customer"}
                                       component={customerServiceFlag == 0 ? QwStep : isComplete == 1 ? Customer : StepByStep}/>
                                <Route path={this.props.match.url + "/fission"}
                                       component={customerServiceFlag == 0 ? QwStep : isComplete == 1 ? Fission : StepByStep}/>
                                <Route path={this.props.match.url + "/drainage"}
                                       component={customerServiceFlag == 0 ? QwStep : isComplete == 1 ? Drainage : StepByStep}/>
                                <Route path={this.props.match.url + "/config"}
                                       component={customerServiceFlag == 0 ? QwStep : ConfigManage}/>
                                <Route path={this.props.match.url + "/assets"}
                                       component={customerServiceFlag == 0 ? QwStep : AssetsRouter}/>
                            </Switch>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default connect(null, null)(Index)